import { Stack, StackProps, styled } from '@mui/material';

import { hexToRgba } from '../../../../../utils/color';

export const Root = styled((props: StackProps) => (
  <Stack justifyContent="center" alignItems="center" p={3} {...props} />
))(({ theme }) => ({
  border: `0.5px solid ${theme.palette.grey[300]}`,
  borderRadius: 8,
  backgroundColor: hexToRgba(theme.palette.common.white, 0.8),
}));
